<script lang="ts" setup>
import { OrganizationsApi } from '~/services/apiClient'
import { useUserStore } from '~/stores/user'

const userStore = useUserStore()
const api = new OrganizationsApi()
const loading = ref(false)

async function goToBillingPortal() {
  const currentUrl = window.location.href
  loading.value = true
  api
    .createBillingSessionOrganizationsBillingSessionPost(currentUrl)
    .then((response) => {
      // Open the billing portal URL in a new tab
      window.open(response.data.url, '_blank')
    })
    .finally(() => {
      loading.value = false
    })
}
const canAccessBilling = computed(() => {
  return userStore.hasManagementPermissions && userStore.isDrayDogOrg
})
</script>

<template>
  <div class="billing-settings">
    <div v-if="!canAccessBilling" class="text-gray-500">
      <p>Only management users can access billing information.</p>
    </div>
    <div v-else>
      <h2 class="text-lg font-semibold mb-4">Billing Management</h2>
      <p class="text-gray-600 mb-6">
        Manage your organization's billing information, invoices, and payment
        methods through our billing portal.
      </p>

      <el-button
        type="primary"
        size="large"
        :loading="loading"
        @click="goToBillingPortal"
      >
        <el-icon class="mr-2">
          <i-material-symbols:credit-card />
        </el-icon>
        Go to Billing Portal
      </el-button>

      <div class="mt-4 text-sm text-gray-500">
        <p>You'll be redirected to a secure billing portal where you can:</p>
        <ul class="list-disc list-inside mt-2 space-y-1">
          <li>View and download invoices</li>
          <li>Update payment methods</li>
          <li>Change billing information</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.billing-settings {
  max-width: 600px;
}
</style>
